export const version = "json-wallets/5.6.1";
//# sourceMappingURL=_version.js.map